import { gql } from 'urql';

export const mutationAddWorkflowOutput = gql`
  mutation AddWorkflowOutput(
    $versionId: String!
    $name: String!
    $code: String!
    $type: IOParameterType!
    $isArray: Boolean!
    $isRequired: Boolean!
  ) {
    addWorkflowOutput(
      input: {
        versionId: $versionId
        name: $name
        code: $code
        type: $type
        isArray: $isArray
        required: $isRequired
        sourceType: VALUE
      }
    ) {
      id
      name
      code
      type
      isArray
      isRequired: required
    }
  }
`;
